module.exports = __webpack_public_path__ + "img/江西.84810636.png";